function getChunks(array, size = 50) {
  const chunks = [];
  while (array.length) {
    chunks.push(array.splice(0, size));
  }
  return chunks;
}

export function fetchReels() {
  let url = null;
  const items = [];
  if (document.querySelectorAll('[data-reel-async]').length) {
    document.querySelectorAll('[data-reel-async]').forEach((item) => {
      url = item.getAttribute('data-reel-async');
      items.push(item.getAttribute('data-item'));
    });
  }
  if (url && items) {
    getChunks([...new Set(items)]).forEach((chunk) => {
      $.ajax({
        url,
        data: { i: chunk },
        method: 'GET',
        success: (resp) => {
          $(resp)[0].querySelectorAll('[data-reel-async]').forEach((item) => {
            const id = item.getAttribute('data-reel-async');
            const firstreel = item.getAttribute('data-reel-first');
            $(`#shoppinglist-select-item-id_${id}`).val(firstreel);
            document.querySelectorAll(`[data-reel-async][data-item="${id}"]`)
              .forEach(elem => $(elem).replaceWith(item.innerHTML));
            $(document).trigger('fetchedReel', [id, item]);
          });
        },
      });
    });
  }
}

$(document).ready(() => {
  fetchReels();
});

export default {};
